import {AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {
    ApiService,
    AuthService,
    handleClassCondition,
    PageService,
    PageType,
    PostService,
    PostType,
    SettingsService,
} from '@gallaghercp/core-frontend';
import {ClientService} from '../../services/client.service';
import {DomSanitizer} from '@angular/platform-browser';
import {APP_CONFIG} from '../../app.config';
import {Observable, Subscription} from "rxjs";
import {ActivatedRoute, Router} from '@angular/router';

@Component({
    selector: 'core-main',
    templateUrl: './main.component.html',
    standalone: false
})

export class MainComponent implements OnInit, AfterViewInit, OnDestroy {

    containerClass?: string;
    page?: any;
    post: any;
    category?: string | boolean;
    delayedLoaded: boolean = true;
    gtm: any;

    isTopNav$?: Observable<boolean>;
    isTopNavTransparent?: boolean;
    notificationsEnabled?: boolean;
    heroImagesEnabled?: boolean;
    hasBlurEffect?: boolean
    isTopNavFullWidth?: boolean;
    isChatEnabled: boolean = APP_CONFIG.chatEnabled ?? false;

    logoUrl!: string;
    protected logoInvertedUrl!: string;

    currentUrl = [APP_CONFIG.frontend, this.router.url].join('');
    today = new Date();

    subscriptions: Subscription = new Subscription();

    constructor(
        protected router: Router,
        protected auth: AuthService,
        protected client: ClientService,
        protected settings: SettingsService,
        protected pages: PageService,
        protected posts: PostService,
        protected api: ApiService,
        protected route: ActivatedRoute,
        protected sanitizer: DomSanitizer,
        protected changeDetectorRef: ChangeDetectorRef,
    ) {
    }

    protected setContainerClass() {
        const body = document.querySelector('body');
        switch (this.router.url) {
            case '/':
            case '/1':
            case '/#main-content':
            case '/default':
                this.containerClass = 'container-fluid p-0';
                // @ts-ignore
                handleClassCondition(true, 'is-home', body);
                this.changeDetectorRef.detectChanges();
                break;
            default:
                this.containerClass = this.isTopNavTransparent ? 'container-fluid p-0' : 'container-fluid';
                // @ts-ignore
                handleClassCondition(false, 'is-home', body);
                this.changeDetectorRef.detectChanges();
                break;
        }
    }

    ngOnInit(): void {
        this.isTopNav$ = this.settings.isTopNavigation();

        this.subscriptions.add(this.settings.isTransparentNavigation().subscribe((state: any) => {
            this.isTopNavTransparent = state;
        }));

        this.subscriptions.add(this.settings.isFullWidthNavigation().subscribe((state: any) => {
            this.isTopNavFullWidth = state;
        }));

        this.subscriptions.add(this.settings.isBlurredBackground().subscribe((state: any) => {
            this.hasBlurEffect = state;
        }));

        this.subscriptions.add(this.settings.showNotifications().subscribe((state: any) => {
            this.notificationsEnabled = state;
        }));

        this.subscriptions.add(this.settings.getAuthenticationType().subscribe((authenticationType: any) => {
            if (!this.auth.isAuthenticated() && authenticationType !== 'public') {
                this.router.navigate(['/login']);
            }
        }));

        this.subscriptions.add(this.settings.showHeroImages().subscribe((state: any) => {
            this.heroImagesEnabled = state;
        }));

        this.subscriptions.add(this.settings.getInvertedLogo().subscribe((logoUrl: any) => {
            this.logoInvertedUrl = logoUrl;
            this.updateLogoUrl();
        }));

        if (APP_CONFIG.gtm) {
            this.gtm = this.sanitizer.bypassSecurityTrustResourceUrl('https://www.googletagmanager.com/ns.html?id=' + APP_CONFIG.gtm);
        }

        this.subscriptions.add(
            this.pages.currentPage$!.subscribe((page: PageType) => {
                if (page) {
                    this.delayedLoaded = false;
                    this.page = <PageType>page;
                    this.post = false;
                    this.posts.currentPost$!.next(false);
                    this.category = this.page.categoryNames && this.page.categoryNames[0]
                        ? this.page.categoryNames[0].toLowerCase().replace(new RegExp(' ', 'g'), '-')
                        : false;
                    this.changeDetectorRef.detectChanges();
                    this.setContainerClass();
                    setTimeout(() => {
                        this.delayedLoaded = true;
                        this.changeDetectorRef.detectChanges();
                    }, 300);
                }
            })
        );

        this.subscriptions.add(
            this.posts.currentPost$!.subscribe((post: PostType) => {
                if (post) {
                    this.delayedLoaded = false;
                    this.post = post;
                    this.page = undefined;
                    this.pages.currentPage$!.next(false);
                    this.category = this.post.categoryNames && this.post.categoryNames[0]
                        ? this.post.categoryNames[0].toLowerCase().replace(new RegExp(' ', 'g'), '-')
                        : false;
                    this.changeDetectorRef.detectChanges();
                    this.setContainerClass();
                    setTimeout(() => {
                        this.delayedLoaded = true;
                        this.changeDetectorRef.detectChanges();
                    }, 300);
                }
            })
        );
    }

    getBackgroundImage(): string {
        if (this.page && this.page.meta && this.page.meta.icon) {
            return String(this.page.meta.icon);
        } else if (this.post && this.post.data.image) {
            return String(this.post.data.image);
        }
        return '';
    }

    updateLogoUrl(): void {
        this.logoUrl = this.logoInvertedUrl ? this.logoInvertedUrl : '';
    }

    ngAfterViewInit() {
        this.setContainerClass();
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

}
